import React, { lazy, Suspense } from 'react';

import { LD } from 'src/app/constants/launch-darkly-flags';
import { useLDFlag } from 'src/app/hooks/use-ld-flag';

const V1 = lazy(() => import('./v1'));
const V2 = lazy(() => import('./v2'));
const V3 = lazy(() => import('./v3'));
const V4 = lazy(() => import('./v4'));

const componentMap = {
  V1,
  V2,
  V3,
  V4,
};

export function Marketing() {
  const flag = useLDFlag<{ variation: string }>(LD.LOGIN_MARKETING);
  const Component = componentMap[flag?.variation ?? 'V1'] ?? V1;

  return (
    <Suspense fallback={<div />}>
      <Component />
    </Suspense>
  );
}
